import { Component, OnInit , Output, Input , ViewChild, EventEmitter , ElementRef} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { DragulaService } from 'ng2-dragula';
import { SnotifyService } from 'ng-snotify';
import * as autoScroll from 'dom-autoscroller';
import { OnDestroy} from '@angular/core';
import { SharedDataService } from '../../service/shared-data.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: '.app-nav-listing',
  templateUrl: './nav-listing.component.html',
  styleUrls: ['./nav-listing.component.scss']
})
export class NavListingComponent implements OnInit, OnDestroy {
  @Input() isLineup = false;
  @Input()
  set pageId(page_string: string) {
    this.page_id = (page_string && page_string.trim()) ? page_string : '';
  }

  @Input() parentPageId: string;

  @Input()
  set showPageId(showPageId_string: string) {
    this.showpageId = (showPageId_string) ? showPageId_string : '';
  }
  @Input()
  set allApi(api_string: string) {
    this.api = (api_string && api_string.trim()) ? api_string : '';
  }
  @Input()
  set metaApi(meta_api_string: string) {
    this.meta_api = (meta_api_string && meta_api_string.trim()) ? meta_api_string : null;
  }
  @Input()
  set searchApi(search_api_string: string) {
    this.search_api = (search_api_string && search_api_string.trim()) ? search_api_string : null;
  }

  @Input()
  set pagePinIds(pagePinIdsArray: any[]) {
    this.pagePinList = (pagePinIdsArray && (pagePinIdsArray.length > 0)) ? pagePinIdsArray : [];
  }
  @Input()
  set pageNavIds(pageNavIdsArray: any[]) {
    this.pageNavList = (pageNavIdsArray && (pageNavIdsArray.length > 0)) ? pageNavIdsArray : [];
  }
  @Input()
  set isnavLinkIds(isnavLinkIdsArray: any[]) {
    this.isNavLinkIds = (isnavLinkIdsArray && (isnavLinkIdsArray.length > 0)) ? isnavLinkIdsArray : [];
  }
  @Input()
  set isHamburger(isHamburger: boolean) {
    this.isHamburgerPage = isHamburger;
  }
  
  @Input()
  set showSearch(showSearch: boolean) {
    this.pageShowSearch = showSearch;
  }
  @Input()
  set showPageNav(showPageNav: boolean) {
    this.pageShowNav = showPageNav;
  }

  @Input()
  set pageType(pageType_string: string) {
    this.getPageType = (pageType_string && pageType_string.trim()) ? pageType_string : null;
  }
  @Input()
  set putApi(putApi_string: string) {
    this.putPageApi = (putApi_string && putApi_string.trim()) ? putApi_string : null;
  }

  @Input()
  set getDragulaId(dragulaId_string: string) {
    this.dragulaId = (dragulaId_string && dragulaId_string.trim()) ? dragulaId_string : null;
  }
  @Output() sendListIdToParentfn = new EventEmitter<any>();
  @Output() sendDataToParentfn = new EventEmitter<any>();
  @Output() sendDeleteIdToParentfn = new EventEmitter<any>();
  @Output() changeEvent = new EventEmitter<any>();
  @ViewChild('autoscroll',{static: false}) autoscroll: ElementRef;
 page_id: string;

 api: string;
 putPageApi: string;
 getPageType: string;
 dragId: number;
 dragIndex: number;
 dragulaId: string;
 isHamburgerPage = false;
 pageShowSearch = false;
 pageShowNav = false;
 showpublish = false;
 showMore = false;
 indexDrop = 0;
 meta_api: string;
 showpageId: string;
 expireAt: string;
 filterList: any;
 routeLinkForList: string;
 pagePinList: any;
 pageNavList: any;
 isNavLinkIds: any;
 islistArray: any[] = [];
 public lastPageNum = -1;
 domainConfig = {};
 lastScrollTop = 0;
  offset = 5;
  facets: any;
  searchQuery: FormControl = new FormControl();
  listArray: any[] = [];
  listIdArray: any[] = [];
  articleList: any[] = [];
  byArticleId = false;
  noresults = false;
  search_api: string;
  public pageNum = 0;
  pageSize = 50;
  pages = 34;
  filterUrl = {};
  singleCalendarConfig = {
    'singleDatePicker': true,
    'showDropdowns': true,
    'timePicker': true,
    'timePicker24Hour': true,
    'timePickerSeconds': true,
    'showCustomRangeLabel': false,
    'alwaysShowCalendars': true,
    'opens': 'center',
    'drops': 'down'
  };
  sortByValueOf: string;
  currentRowSelected = 1;

  constructor(
    private config: Config,
    private restService: RestDataService,
    private dragulaService: DragulaService,
    private snotify: SnotifyService,
    private sharedService: SharedDataService
    ) {
        this.domainConfig = this.sharedService.currentDomainConfiguration;
        const bag: any = this.dragulaService.find('six-bag');
        if (bag === undefined ) {
        dragulaService.setOptions('six-bag', {
          copy: function (el, source) {
            return source.id === 'left';
          },
          accepts: function(el, target, source, sibling) {
            return target.id !== 'left';
          },
          moves: function (el: any, container: any, handle: any): any {
            return (el.className !== 'ex-over-opac');
          },
          copySortSource: false
        });
      }

    dragulaService.dropModel.subscribe((value) => {
      this.onDropModel(value.slice(1));
    });
    dragulaService.removeModel.subscribe((value) => {
      this.onRemoveModel(value.slice(1));
    });
    dragulaService.drop.subscribe((value) => {
      this.onDrop(value.slice(1));
    });
  }
  ngOnInit() {
    if (!this.pageShowSearch) {
    setTimeout(() => {
      const scroll = autoScroll([
        this.autoscroll.nativeElement
      ], {
          margin: 30,
          maxSpeed: 10,
          scrollWhenOutside: true,
          autoScroll: function () {
            return this.down;
          }
        });
    }, 1000);
  }
    if (!this.pageShowSearch) {
      this.getDefaultList(0, data => {
        if (data && data.links && data.links.length > 0) {
          this.listArray = [];
          this.listIdArray = [];
          this.dataInsertion(data.links);
          this.sendListIdToParentfn.emit(data.modificationHistory);
          this.noresults = false;
        } else {
          this.noresults = true;
        }
      });
    } else {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.meta_api)
      )
        .subscribe(data => {
          this.facets = data;
        });
      this.searchQuery.valueChanges
      .pipe(debounceTime(200)
      ,distinctUntilChanged())
      .subscribe(result => {
        this.searchResults(result, 0, data => {
          this.pageNum = 0;
          this.listArray = [];
          this.listIdArray = [];
          if (data['content'].length > 0) {
            this.dataInsertion(data['content']);
            this.noresults = false;
          } else {
            this.noresults = true;
          }
        });
      });

      const filters = this.config.getFilters(this.config.get('views'), this.page_id);
      this.filterList = this.sharedService.getUpdatedFilters(filters);
    }

    this.routeLinkForList = this.config.getKeyInView(this.config.get('views'), this.page_id, 'list_router');
  }
  dataInsertion(data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i] !== null && this.parentPageId !== data[i].id) {
        this.listArray.push(data[i]);
        this.listIdArray.push(data[i].id);
      }
    }
  }
  getDefaultList(pageNum, callback) {
    if (this.config.getEndPoint(this.config.get('views'), this.page_id, this.api) !== 'false') {
      let url = this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.api);
        if (this.showpageId) {
          url += this.showpageId;
        }
        url += '?size=' + this.pageSize + '&page=' + pageNum;
        if (this.getPageType)  {
           url += ',pageType:' + this.getPageType;
         }
        if (!this.showpageId) {
          if(this.sharedService.isdomainConfig('pages','showPrimaryPage')) {
            url += '&search=status:PUBLISHED';
          } else {
            url += '&search=status:PUBLISHED,pageType!PRIMARY';
          }
          if (this.filterUrl) {
            for (const filter in this.filterUrl) {
              if (filter) {
                url += this.filterUrl[filter];
              }
            }
          }
          if (url.indexOf('EXTERNAL') === -1) {
            url += ',pageType!EXTERNAL';
          }
       }
       url += '&sort=lastModifiedDate,desc';
      this.restService.http_get(url)
        .subscribe(data => {
          this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
          this.topFunction();
          callback(data);
        });
    } else {
      console.log('url not found');
    }
  }
  searchResults(query, pageNum, callback) {
    if (this.config.getEndPoint(this.config.get('views'), this.page_id, this.search_api) !== 'false') {
      if (this.search_api && query) {
        let url = this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, this.search_api)
          + '?size=' + this.pageSize + '&page=' + pageNum;

          if(this.sharedService.isdomainConfig('pages','showPrimaryPage')) {
            url += '&search=status:PUBLISHED';
          } else {
            url += '&search=status:PUBLISHED,pageType!PRIMARY';
          }
        // url += '&search=status:PUBLISHED,pageType!PRIMARY';
         if (this.getPageType) {
             url += ',pageType:' + this.getPageType;
          }
        if (this.filterUrl) {
          for (const filter in this.filterUrl) {
            if (filter) {
              url += this.filterUrl[filter];
            }
          }
        }
        if (url.indexOf('EXTERNAL') === -1) {
          url += ',pageType!EXTERNAL';
        }
        if (query && query.trim() !== '') {
          url += ',name~' + query;
        }

        url += '&sort=lastModifiedDate,desc';

        this.restService.http_get(url)
          .subscribe(data => {
            this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
            this.topFunction();
            callback(data);
          },
          error => {
            console.log(error);
          });
      } else {
        this.getDefaultList(pageNum, data => {
          callback(data);
        });
      }
    } else {
      console.log('url not found');
    }
  }
  urlUpdate(ev) {
    this.filterUrl[ev.type] = ev.data;
    this.pageNum = 0;
    this.searchResults(this.searchQuery.value, this.pageNum, data => {
      this.listArray = [];
      this.listIdArray = [];
      if (data['content'].length > 0) {
        this.dataInsertion(data['content']);
        this.noresults = false;
      } else {
        this.noresults = true;
      }
    });
  }
  getFilterData(facet_name) {
    if (this.facets && this.facets[facet_name]) {
      return this.facets[facet_name];
    } else {
      return null;
    }
  }
  
  topFunction() {
    this.currentRowSelected = 1;
    document.body.scrollTop = 0; // For Safari
    if (document.getElementsByClassName('contentList') && document.getElementsByClassName('contentList').length > 0) {
      document.getElementsByClassName('contentList')[0].scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }

  idToDelete(id) {
      this.pageNavList = this.pageNavList.filter(i => i.id !== id);
      this.sendDeleteIdToParentfn.emit(this.pageNavList);
  }
  onDrop(args) {
    const [el, target , source , e] = args;
    if (e != null) {
    this.indexDrop = +e.value;
    }
  }
  private onDropModel(args) {
    if (!this.pageShowSearch) {
      const [el, target , source] = args;
        if (this.pageNavList) {
          if (source.id === 'left') {
            let hasDuplicate = false;
            this.pageNavList.map(v => v.name).sort().sort((a, b) => {
              if (a === b) { hasDuplicate = true; }
              });
            if (hasDuplicate) {
              this.pageNavList = this.pageNavList.filter(i => i.id !== +el.id);
              this.pageNavList.splice(this.indexDrop, 0, {id : +el.id});
            }
          }
          this.sendDataToParentfn.emit(this.pageNavList);
        }
    }
  }
  private onRemoveModel(args) {
    const [el , target, source] = args;
  }


  htmlToPlaintext(text) {
    if (typeof text === 'string') {
      return text ? String(text).replace(/<[^>]+>/gm, '') : '';
    } else {
      return text;
    }
  }
  ngOnDestroy() {
  }
  showPrimaryPage() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['pages'] && this.domainConfig['config']['pages']['showPrimaryPage'] === 'true');
  }
}
